import FJTextToImageConfig from '../../config/appConfig/FJTextToImageConfig';
import FJConstant from '../../constants/FJConstant';
import FJNetworkStore from '../../store/FJNetworkStore';
import {
    setSliceAiTextToImageHistoryList,
    setSliceAiTextToImageHistoryLoadStatus,
    setSliceIsShowAIImageHistoryModal,
    setSliceAiImageToImageHistoryLoadStatus,
    setSliceAiImageToImageHistoryList,
} from '../slices/FJSliceAiHistoryCommon';
import FJUtil from '../../util/FJUtil';
import FJAppConstant from '../../constants/FJAppConstant';
import FJImageToImageConfig from '../../config/appConfig/FJImageToImageConfig.js';

const FJActionAiHistoryCommon = {
    /**
     * @desc 初始化ai文本到图像历史记录列表
     * @returns
     */
    initAiTextToImageHistoryList: function (isRefresh = false) {
        return async (dispatch, getState) => {
            const { aiTextToImageHistoryLoadStatus } = getState().aiHistoryCommon;
            if (
                (aiTextToImageHistoryLoadStatus === FJConstant.LOADING ||
                    aiTextToImageHistoryLoadStatus === FJConstant.SUCCESS) &&
                !isRefresh
            )
                return;

            try {
                dispatch(setSliceAiTextToImageHistoryLoadStatus(FJConstant.LOADING));

                const list = await FJNetworkStore.getTaskList(FJTextToImageConfig.historyListType);
                if (list && list.length) {
                    const historyList = await FJUtil.parseList(list, {
                        type: FJConstant.HISTORY,
                        resultImageKey: FJTextToImageConfig.resultImageKey,
                        originalImageKey: FJTextToImageConfig.originalImageKey,
                        appType: FJAppConstant.TEXT_TO_IMAGE,
                    });
                    dispatch(setSliceAiTextToImageHistoryList(historyList));
                } else {
                    dispatch(setSliceAiTextToImageHistoryList([]));
                }
                dispatch(setSliceAiTextToImageHistoryLoadStatus(FJConstant.SUCCESS));
            } catch (error) {
                dispatch(setSliceAiTextToImageHistoryList([]));
                dispatch(setSliceAiTextToImageHistoryLoadStatus(FJConstant.ERROR));
            }
        };
    },

    /**
     * @desc 初始化ai图像到图像历史记录列表
     * @returns
     */
    initAiImageToImageHistoryList: function (isRefresh = false) {
        return async (dispatch, getState) => {
            const { aiImageToImageHistoryLoadStatus } = getState().aiHistoryCommon;
            if (
                (aiImageToImageHistoryLoadStatus === FJConstant.LOADING ||
                    aiImageToImageHistoryLoadStatus === FJConstant.SUCCESS) &&
                !isRefresh
            )
                return;

            try {
                dispatch(setSliceAiImageToImageHistoryLoadStatus(FJConstant.LOADING));

                const list = await FJNetworkStore.getTaskList(FJImageToImageConfig.historyListType);
                if (list && list.length) {
                    const historyList = await FJUtil.parseList(list, {
                        type: FJConstant.HISTORY,
                        resultImageKey: FJImageToImageConfig.resultImageKey,
                        originalImageKey: FJImageToImageConfig.originalImageKey,
                        appType: FJAppConstant.IMAGE_TO_IMAGE,
                    });
                    dispatch(setSliceAiImageToImageHistoryList(historyList));
                } else {
                    dispatch(setSliceAiImageToImageHistoryList([]));
                }
                dispatch(setSliceAiImageToImageHistoryLoadStatus(FJConstant.SUCCESS));
            } catch (error) {
                dispatch(setSliceAiImageToImageHistoryList([]));
                dispatch(setSliceAiImageToImageHistoryLoadStatus(FJConstant.ERROR));
            }
        };
    },

    /**
     * @description
     * @param isShow
     * @returns {(function(*): void)|*}
     */
    setIsShowAIImageHistoryModalAction: function (isShow) {
        return dispatch => {
            dispatch(setSliceIsShowAIImageHistoryModal(isShow));
        };
    },

    /**
     * @description
     * @returns {(function(*): void)|*}
     */
    showAIImageHistoryListAction: function () {
        return dispatch => {
            dispatch(this.setIsShowAIImageHistoryModalAction(true));
            dispatch(this.initAiTextToImageHistoryList());
            dispatch(this.initAiImageToImageHistoryList());
        };
    },
};

export default FJActionAiHistoryCommon;
